import { Alert, Button, Group, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useControlConfirmationStatus } from "../../hooks/useWorkflows";

const ACCESSIONING_TYPES_NOT_REQUIRING_HE_CONTROL = [
  "pass_through",
  "consultation",
];

interface HeControlBannerProps {
  onConfirmClick: () => void;
  accessioningType?: string;
}

export function HeControlBanner({
  onConfirmClick,
  accessioningType,
}: HeControlBannerProps) {
  // When accessioningType is provided, skip for external-slide types (pass_through, consultation).
  // When omitted (e.g. queue-level usage), always show the banner.
  const requiresHeControl = accessioningType
    ? !ACCESSIONING_TYPES_NOT_REQUIRING_HE_CONTROL.includes(accessioningType)
    : true;

  const { data: status, isLoading } = useControlConfirmationStatus({
    enabled: requiresHeControl,
  });

  if (!requiresHeControl || isLoading || status?.confirmed) {
    return null;
  }

  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      color="orange"
      title="H&E Controls Not Confirmed"
      mb="md"
      style={{ maxWidth: 650 }}
    >
      <Group justify="space-between" align="center">
        <Text size="sm">
          H&E control slides have not been confirmed for today.
        </Text>
        <Button size="xs" variant="filled" onClick={onConfirmClick}>
          Confirm Controls
        </Button>
      </Group>
    </Alert>
  );
}
